import { RouteErrorBoundary } from 'es/app/components/layout/RouteErrorBoundary';
import SystemRouteMap from 'es/app/views/system/RouteMap';
import { SSOUserTemplateAccessGroups } from 'es/app/views/system/sso-user-templates/edit/SSOUserTemplateAccessGroups';
import { SSOUserTemplateDetails } from 'es/app/views/system/sso-user-templates/edit/SSOUserTemplateDetails';
import { lazy } from 'react';
import { Route } from 'react-router';

const SsoUserTemplates = lazy(() => import('es/app/views/system/sso-user-templates/SsoUserTemplates'));
const EditSSOUserTemplate = lazy(() => import('es/app/views/system/sso-user-templates/edit/EditSSOUserTemplate'));

export function SsoUserTemplateRoutes() {
    return (
        <>
            <Route
                path={SystemRouteMap.ssoUserTemplates.search()}
                element={<SsoUserTemplates />}
                ErrorBoundary={RouteErrorBoundary}
            >
                <Route path={SystemRouteMap.ssoUserTemplates.create().root} element={<EditSSOUserTemplate />}>
                    <Route index element={<SSOUserTemplateDetails />} />
                    <Route
                        path={SystemRouteMap.ssoUserTemplates.create().accessGroups}
                        element={<SSOUserTemplateAccessGroups />}
                    />
                </Route>
                <Route path={SystemRouteMap.ssoUserTemplates.edit().root} element={<EditSSOUserTemplate />}>
                    <Route index element={<SSOUserTemplateDetails />} />
                    <Route
                        path={SystemRouteMap.ssoUserTemplates.edit().accessGroups}
                        element={<SSOUserTemplateAccessGroups />}
                    />
                </Route>
            </Route>
        </>
    );
}
